import { createSelector } from "reselect";

import { RootState } from "redux/reducers/rootReducer";

export const getAgeGate = (state: RootState) => state.ageGate;

export const getShowAgeGate = createSelector(
  getAgeGate,
  (ageGate) => ageGate.showingModal
);
